// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._fAffaFAkuY7fCqawojL{flex-direction:column;flex-grow:1;width:760px;margin:0 auto;padding:64px 20px 0;display:flex;position:relative}.mutpq7daQ2l84U0sSabI{flex-direction:column;gap:4px;display:flex}.GD3l8ogX6YpmXwpGPqm0{flex-direction:column;gap:16px;margin-top:48px;display:flex}.GD5oADGHU4xau3EORBDs{background-color:var(--white-100);opacity:.5;z-index:var(--zIndex-BASE_9);position:absolute;top:0;bottom:0;left:0;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `_fAffaFAkuY7fCqawojL`,
	"addOnsHeader": `mutpq7daQ2l84U0sSabI`,
	"addOnsContent": `GD3l8ogX6YpmXwpGPqm0`,
	"loaderWrapper": `GD5oADGHU4xau3EORBDs`
};
export default ___CSS_LOADER_EXPORT___;
